const KEY = 'feedScrollPos'
const MAX_AGE_MS = 30_000

interface Saved { top: number; at: number }

export const feedScroll = {
  save(top: number) {
    sessionStorage.setItem(KEY, JSON.stringify({ top, at: Date.now() }))
  },
  /** Returns saved position and removes it. Returns null if absent or stale. */
  consume(): number | null {
    const raw = sessionStorage.getItem(KEY)
    sessionStorage.removeItem(KEY)
    if (!raw) return null
    const { top, at } = JSON.parse(raw) as Saved
    return Date.now() - at <= MAX_AGE_MS ? top : null
  },
}
